import { apiFetch } from "@/lib/api";

export type AttractionTicket = {
  id?: number;
  title?: string | null;
  description?: string | null;
  pricing_type?: string | null;
  cost_supplier?: number | null;
  website_price?: number | null;
  price_op?: number | null;
  price_ag?: number | null;
  price_cf?: number | null;
  tax_percentage?: number | null;
};

export type Attraction = {
  id: number;
  attraction_code: string;
  title: string;
  description?: string | null;
  supplier_name?: string | null;
  opening_hours?: string | null;
  tax_percentage?: number | null;
  hcte_notes?: string | null;
  image_url?: string | null;
  tickets?: AttractionTicket[];
  created_at?: string;
  updated_at?: string;
};

export type AttractionTicketListItem = {
  id: number;
  title: string;
};

export type AttractionListItem = {
  id: number;
  attraction_code: string;
  title: string;
  supplier_name?: string | null;
  tickets?: AttractionTicketListItem[];
};

export type AttractionListResponse = {
  items: AttractionListItem[];
  total: number;
};

export const fetchAttractions = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<AttractionListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<AttractionListResponse | null>(`/attractions?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getAttraction = async (id: number): Promise<Attraction> => {
  return apiFetch<Attraction>(`/attractions/${id}`);
};

export const createAttraction = async (data: Partial<Attraction>): Promise<Attraction> => {
  return apiFetch<Attraction>("/attractions", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createAttractionAllowDuplicates = async (data: Partial<Attraction>): Promise<Attraction> => {
  return apiFetch<Attraction>("/attractions?allow_duplicates=true", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateAttraction = async (id: number, data: Partial<Attraction>): Promise<Attraction> => {
  return apiFetch<Attraction>(`/attractions/${id}` , {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAttraction = async (id: number): Promise<void> => {
  await apiFetch<void>(`/attractions/${id}`, { method: "DELETE" });
};

export const deleteAllAttractions = async (): Promise<void> => {
  await apiFetch<void>("/attractions", { method: "DELETE" });
};

export const getAttractionTicket = async (attractionId: number, ticketId: number): Promise<AttractionTicket> => {
  return apiFetch<AttractionTicket>(`/attractions/${attractionId}/tickets/${ticketId}`);
};
